<!-- dashboard/routes/dashboard/settings/account/components/auto-resolve/ConfigCard.vue -->
<script setup>
const props = defineProps({
  config: {
    type: Object,
    required: true,
  },
  type: {
    type: String,
    required: true,
    validator: (v) => ['label', 'agent', 'team'].includes(v),
  },
  formatDuration: {
    type: Function,
    required: true,
  },
});

const emit = defineEmits(['edit', 'remove']);
</script>

<template>
  <div class="group bg-n-solid-1 border border-n-weak rounded-xl p-4 hover:border-n-slate-6 transition-colors">
    <!-- Header -->
    <div class="flex justify-between items-start mb-3">
      <div class="flex items-center gap-2 min-w-0">
        <span
          v-if="type === 'label' && config.color"
          class="w-2.5 h-2.5 rounded flex-shrink-0"
          :style="{ backgroundColor: config.color }"
        />
        <h4 class="text-sm font-medium text-n-slate-12 truncate">
          {{ config.name }}
        </h4>
      </div>
      
      <!-- Actions -->
      <div class="flex gap-0.5 opacity-0 group-hover:opacity-100 transition-opacity">
        <button
          @click="emit('edit')"
          class="p-1.5 text-n-slate-10 hover:text-n-slate-12 hover:bg-n-alpha-1 rounded-md transition-colors"
        >
          <span class="i-lucide-pencil w-3.5 h-3.5" />
        </button>
        <button
          @click="emit('remove')"
          class="p-1.5 text-n-slate-10 hover:text-n-ruby-11 hover:bg-n-ruby-3 rounded-md transition-colors"
        >
          <span class="i-lucide-trash-2 w-3.5 h-3.5" />
        </button>
      </div>
    </div>

    <!-- Duration - Destaque principal -->
    <div class="text-xl font-semibold text-n-slate-12 mb-2">
      {{ formatDuration(config.duration) }}
    </div>

    <!-- Message -->
    <p v-if="config.message" class="text-sm text-n-slate-10 line-clamp-2 mb-3">
      {{ config.message }}
    </p>

    <!-- Tags -->
    <div v-if="config.label?.name || config.ignoreWaiting" class="flex flex-wrap gap-1.5">
      <span
        v-if="config.label?.name"
        class="inline-flex items-center gap-1.5 px-2 py-0.5 bg-n-alpha-1 rounded text-xs text-n-slate-11"
      >
        <span
          class="w-2 h-2 rounded-sm flex-shrink-0"
          :style="{ backgroundColor: config.label.color }"
        />
        {{ config.label.name }}
      </span>

      <span
        v-if="config.ignoreWaiting"
        class="inline-flex items-center gap-1 px-2 py-0.5 bg-n-alpha-1 rounded text-xs text-n-slate-11"
      >
        <span class="i-lucide-clock w-3 h-3" />
        Ignora aguardando
      </span>
    </div>
  </div>
</template>